var _path, _mask, _path2, _mask2, _path3, _mask3, _path4, _mask4, _path5, _mask5, _path6, _mask6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V14.3654H15.2667V12.0096H18.0667V15.6442M12 16.1154V18H19",
    stroke: "#747D90",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H9.47057V9.47057H1V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V-0.5H-0.5V1H1ZM9.47057 1H10.9706V-0.5H9.47057V1ZM9.47057 9.47057V10.9706H10.9706V9.47057H9.47057ZM1 9.47057H-0.5V10.9706H1V9.47057ZM1 2.5H9.47057V-0.5H1V2.5ZM7.97057 1V9.47057H10.9706V1H7.97057ZM9.47057 7.97057H1V10.9706H9.47057V7.97057ZM2.5 9.47057V1H-0.5V9.47057H2.5Z",
    fill: "#747D90",
    mask: "url(#path-2-inside-1_4293_16572)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 4.17636H6.29391V6.294H4.17627V4.17636Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 4.17636V2.67636H2.67627V4.17636H4.17627ZM6.29391 4.17636H7.79391V2.67636H6.29391V4.17636ZM6.29391 6.294V7.794H7.79391V6.294H6.29391ZM4.17627 6.294H2.67627V7.794H4.17627V6.294ZM4.17627 5.67636H6.29391V2.67636H4.17627V5.67636ZM4.79391 4.17636V6.294H7.79391V4.17636H4.79391ZM6.29391 4.794H4.17627V7.794H6.29391V4.794ZM5.67627 6.294V4.17636H2.67627V6.294H5.67627Z",
    fill: "#747D90",
    mask: "url(#path-4-inside-2_4293_16572)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5291H9.47057V18.9997H1V10.5291Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5291V9.02908H-0.5V10.5291H1ZM9.47057 10.5291H10.9706V9.02908H9.47057V10.5291ZM9.47057 18.9997V20.4997H10.9706V18.9997H9.47057ZM1 18.9997H-0.5V20.4997H1V18.9997ZM1 12.0291H9.47057V9.02908H1V12.0291ZM7.97057 10.5291V18.9997H10.9706V10.5291H7.97057ZM9.47057 17.4997H1V20.4997H9.47057V17.4997ZM2.5 18.9997V10.5291H-0.5V18.9997H2.5Z",
    fill: "#747D90",
    mask: "url(#path-6-inside-3_4293_16572)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 13.7054H6.29391V15.8231H4.17627V13.7054Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17627 13.7054V12.2054H2.67627V13.7054H4.17627ZM6.29391 13.7054H7.79391V12.2054H6.29391V13.7054ZM6.29391 15.8231V17.3231H7.79391V15.8231H6.29391ZM4.17627 15.8231H2.67627V17.3231H4.17627V15.8231ZM4.17627 15.2054H6.29391V12.2054H4.17627V15.2054ZM4.79391 13.7054V15.8231H7.79391V13.7054H4.79391ZM6.29391 14.3231H4.17627V17.3231H6.29391V14.3231ZM5.67627 15.8231V13.7054H2.67627V15.8231H5.67627Z",
    fill: "#747D90",
    mask: "url(#path-8-inside-4_4293_16572)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5295 1H19.0001V9.47057H10.5295V1Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5295 1V-0.5H9.02954V1H10.5295ZM19.0001 1H20.5001V-0.5H19.0001V1ZM19.0001 9.47057V10.9706H20.5001V9.47057H19.0001ZM10.5295 9.47057H9.02954V10.9706H10.5295V9.47057ZM10.5295 2.5H19.0001V-0.5H10.5295V2.5ZM17.5001 1V9.47057H20.5001V1H17.5001ZM19.0001 7.97057H10.5295V10.9706H19.0001V7.97057ZM12.0295 9.47057V1H9.02954V9.47057H12.0295Z",
    fill: "#747D90",
    mask: "url(#path-10-inside-5_4293_16572)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_4293_16572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7058 4.17636H15.8235V6.294H13.7058V4.17636Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7058 4.17636V2.67636H12.2058V4.17636H13.7058ZM15.8235 4.17636H17.3235V2.67636H15.8235V4.17636ZM15.8235 6.294V7.794H17.3235V6.294H15.8235ZM13.7058 6.294H12.2058V7.794H13.7058V6.294ZM13.7058 5.67636H15.8235V2.67636H13.7058V5.67636ZM14.3235 4.17636V6.294H17.3235V4.17636H14.3235ZM15.8235 4.794H13.7058V7.794H15.8235V4.794ZM15.2058 6.294V4.17636H12.2058V6.294H15.2058Z",
    fill: "#747D90",
    mask: "url(#path-12-inside-6_4293_16572)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.77e7d60711a0366c01bf6da3f49ab01d.svg";
export { ForwardRef as ReactComponent };